module.exports = __webpack_public_path__ + "static/media/gallerryimg1.257e3a41.JPG";